import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MainToolbarHeaderInfo } from '../../se-toolbar/se-header-toolbar/se-header-info/se-header-info.component';
import { CustomPageConfig } from '../../models/custom-page';

export interface ICustomPageToolbar {
    config: CustomPageConfig;
    info1: MainToolbarHeaderInfo;
    info2: MainToolbarHeaderInfo;
}

export interface ICustomPageToolbarResolver {
    getToolbar(): Observable<ICustomPageToolbar>;
}

export const CustomPageToolbarResolver = new InjectionToken('CustomPageToolbarResolver');

@Injectable()
export class EmptyToolbarResolver implements ICustomPageToolbarResolver {
    getToolbar() {
        return of({
            config: new CustomPageConfig(null, null, null),
            info1: { mainDescription: '', secondaryDescription: '', infoList: [] },
            info2: { mainDescription: '', secondaryDescription: '', infoList: [] },
        });
    }
}
